<div id="user-list-pane" *ngIf="displayPane==0">
  <h3>{{currentCustomer.Name}}</h3>
  <div id="user-grid">
    <kendo-grid [data]="gridViewUserList" [selectable]="true" [selectable]="true" [sortable]="{allowUnsort: true, mode:'single'} "
      [sort]="sortUserList" (sortChange)="sortChangeUserList($event)">
      <kendo-grid-column title="" [width]="120">
        <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
          <div class="raui-grid-buttons raui-nowrap">
            <a class="cvt-icon-edit grid-cmd-icons" title="Edit User" (click)="editUserClick(rowIndex)"></a>
            <a class="cvt-icon-trash grid-cmd-icons" title="Delete User" (click)="deleteUserClick(rowIndex)"></a>
            <a class="cvt-icon-hide grid-cmd-icons" title="Suspend User" (click)="suspendUserClick(rowIndex)"></a>
            <a class="cvt-icon-lock grid-cmd-icons" title="Lock User" (click)="lockUserClick(rowIndex)"></a>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="AccountStatusIDText" title="Status" [width]="80">
      </kendo-grid-column>
      <kendo-grid-column field="RoleString" title="Access Level" [width]="120">
      </kendo-grid-column>
      <kendo-grid-column field="UserName" title="User Name" [width]="120">
      </kendo-grid-column>
      <kendo-grid-column field="LastName" title="Last Name" [width]="120">
      </kendo-grid-column>
      <kendo-grid-column field="FirstName" title="First Name" [width]="120">
      </kendo-grid-column>
      <kendo-grid-column field="EMailAddress" title="EMail" [width]="150">
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <div>
    <button class="k-button cvt-primary" (click)="linkUser()">Link User</button>
  </div>
  <div kendoDialogContainer *ngIf='showMB'></div>
  <app-modal (onOkToParent)='okCloseButtonClick(true)' (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal' [dialogTitle]="dialogTitle"
    [dialogTextLine1]="dialogTextLine1" [dialogTextLine2]="''" [primaryButtonText]="'OK'" [secondaryButtonText]="cancelButton"></app-modal>
  <div *ngIf="false">
    <span class="spinner k-icon k-i-loading"></span>
  </div>
  <div *ngIf="userListBusyIndicator.isBusy" class="SpinnerContainer" data-cvent-id="spinner" data-reactid="120">
    <div class="SpinnerouterCircle Spinnercircle Spinnercircle" data-reactid="121"></div>
    <div class="SpinnermiddleCircle Spinnercircle Spinnercircle" data-reactid="122"></div>
    <div class="SpinnerinnerCircle Spinnercircle Spinnercircle" data-reactid="123"></div>
  </div>
  <app-add-edit-user [userID]="''" [ngStyle]="addEditUserStyle" ></app-add-edit-user>
